module.exports = __webpack_public_path__ + "img/1.54df6110.png";